<template>

  <div v-if="this.pageDevice != null && isLoginUserPageItemWritable">

    <deviceTabs :current="'auth'" :pageDevice="pageDevice" :pageUser="pageUser" />

    <div class="m-0 mt-3 mr-2" v-if="pageDevice.disabled">
      <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger">
        정지 중이므로 기기의 인증코드를 설정할 수 없습니다.
      </b-alert>
    </div>

    <p class="m-0 mt-2 mr-2 gothic">
      다음은 이 기기의 시리얼번호와 접속코드입니다.
    </p>

    <b-form @submit.stop.prevent class="was-validated mt-2" v-if="serial != '' && pageDevice.acode != ''">

      <b-input-group size="sm">
        <b-input-group-text slot="prepend" class="leftCellTitleTiny">
          <label for="serialNumber" style="margin-bottom : 0rem">시리얼번호</label>
        </b-input-group-text>
        <b-form-input  v-touch:swipe.stop :value="this.serial" id="serialNumber" readonly/>
        <b-button slot="append" variant="outline-secondary" v-b-tooltip.click title="시리얼번호는 변경할 수 없습니다. 시리얼번호를 재사용하려면 등록된 기기를 삭제해야 합니다.">?</b-button>
      </b-input-group>

      <b-input-group size="sm" class="mt-2">
        <b-input-group-text slot="prepend"  class="leftCellTitleTiny">
          <label for="accessCode" style="margin-bottom : 0rem">접속코드</label>
        </b-input-group-text>
        <b-form-input  v-touch:swipe.stop disabled readonly :value="pageDevice.acode" :title="pageDevice.acode" id="accessCode"/>
        <b-button slot="append" variant="outline-secondary" v-b-tooltip.click v-if="!this.pageBinded" title="실시간 꺼짐이면 접속코드를 바꿀 수 없습니다. 접속코드는 IoT 기기에서 업로딩할 때 ID와 비번 대신 사용합니다.">?</b-button>

        <b-button slot="append" variant="primary" v-clipboard:copy="pageDevice.acode" v-clipboard:success="acodeCopy" v-clipboard:error="acodeCopyError">복사하기</b-button>

        <b-button slot="append" type="button" v-b-modal.changeAcodeFloat variant="secondary" :disabled="!this.pageBinded">
          바꾸기
        </b-button>
      </b-input-group>

      <b-input-group size="sm" class="mt-2">
        <b-input-group-text slot="prepend" class="leftCellTitleTiny">
          <label for="serialNumber" style="margin-bottom : 0rem">업로드 전달</label>
        </b-input-group-text>
        <b-form-input  v-touch:swipe.stop :value="pageDevice.relayTo" id="serialNumber" readonly/>
        <b-button slot="append" variant="outline-secondary" v-b-tooltip.click title="기기에 따라서 다른 웹사이트로 업로드 전달이 설정된 경우에 여기에 표시됩니다. 업로드 전달할 주소를 직접 지정한 경우에는 custom으로 표시됩니다.">?</b-button>
      </b-input-group>
      
    </b-form>

    <p class="m-0 mt-3 mr-2 gothic" v-if="typeof(pageDevice.oAdmin) != 'undefined' && pageDevice.oAdmin != '' && loginUser.id != pageDevice.oAdmin && loginUser.id == pageUser.id">
      <b class="text-danger">주의</b>: 이 기기에서 사용중인 시리얼번호는
      <router-link :to="{ name: 'tinkUser', params: { uid: pageDevice.oAdmin } }" custom v-slot="{ navigate }">
        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
          {{ pageDevice.oAdmin }}
        </span>
      </router-link>의 것입니다.
      <router-link :to="{ name: 'tinkUser', params: { uid: pageDevice.oAdmin } }" custom v-slot="{ navigate }">
        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
          {{ pageDevice.oAdmin }}
        </span>
      </router-link>는 언제든지 <b class="text-danger">이 기기의 소유권을 가져갈 수 있습니다</b>.
    </p>

    <p class="m-0 mt-3 mr-2 gothic">
      접속코드가 정상적으로 동작하는 지는 접속코드를 사용하여 데이터를 보내서 서버에 저장을 해보면 됩니다.
      <router-link :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'upload' } }" custom v-slot="{ navigate }">
        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
          테스트 탭
        </span>
      </router-link>에서 데이터를 보내는 테스트를 할 수 있습니다.
    </p>

    <b-modal v-touch:swipe.stop size="lg" id="changeAcodeFloat" tabindex="-1" title="접속코드 변경하기" static @show="modalShowFocus" data-nextfocus="changeAcodeConfirmInput" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
      <p class="gothic fontSizeDot9">
        아래 입력칸에 시리얼번호인 <b><big class="gothic" style="letter-spacing: 2px; color: red;">{{this.serial}}</big></b>를 입력해주세요. 시리얼번호는 aaaa-aaaa-aaaa-aaaa와 같은 형식이고 대소문자 구분합니다.
      </p>
      <b-form @submit.stop.prevent class="was-validated">
        <b-input-group>
          <b-input-group-text slot="prepend">
            <label for="" style="margin-bottom : 0rem">시리얼번호</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop :disabled="changeAcodeDisabled" id="changeAcodeConfirmInput" placement="bottom" v-b-tooltip.focus title="" trim maxlength="19" minlength="19" v-model="changeAcodeConfirmSerial" @keydown="disableCtrlV" @contextmenu="disableContextMenu" class="gothic" style="letter-spacing: 2px; color: red; font-weight: bold;" :pattern="'^' + this.serial + '$'"/>
        </b-input-group>
      </b-form>
      <b-tooltip target="changeAcodeConfirmInput" placement="left">
        시리얼번호를 입력해주세요.<br/>
        Ctrl+V는 안되요.<br/>
        마우스 붙여넣기도 안되요.
      </b-tooltip>
      <template slot="modal-footer">
        <b-button variant="danger" size="sm" @click="closeChangeAcodeModal">
          <b-spinner small type="grow" class="mr-1" v-if="showSpinner"></b-spinner>
          취소하기
        </b-button>
        <b-button variant="secondary" size="sm" @click="changeAcode" :disabled="changeAcodeDisabled || !this.pageBinded">
          <b-spinner small type="grow" class="mr-1" v-if="showSpinner"></b-spinner>
          변경하기
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

import uiUtil from "@/mixins/util.js"
import mapUtil from "@/mixins/mapUtil.js"
import user from "@/mixins/user.js"
import functions from "@/mixins/functions.js"

import deviceTabs from "@/components/device/deviceTabs.vue"


export default {
  name: "deviceAuth",
  mixins: [uiUtil, mapUtil, user, functions],
  props: {
    pageUser: Object,
    pageDevice: Object,
    pageBinded: Boolean,
    serial: String,
  },
  components: {
    deviceTabs,
  },
  data: function() {
    return {
      changeAcodeDisabled: false,
      changeAcodeConfirmSerial: "",
      showSpinner: false,
      testData: "",
      testResult: "실행결과 없음",
    }
  },
  mounted: function() {
    firebase.auth().onAuthStateChanged(() => {
      if(firebase.auth().currentUser != null  && this.isLoginUserPageItemWritable) {
        this.$parent.$parent.getSerial()
      }
    })
    if(this.serial == "") {
      this.$parent.$parent.getSerial()
    }
  },
  methods: {
    acodeCopy: function() {
      this.makeToast("success", "접속코드 복사 성공", "접속코드를 복사했습니다. 접속코드: " + this.pageDevice.acode)
    },
    acodeCopyError : function(error) {
      this.makeToast("danger", "접속코드 복사 실패", "접속코드 복사 중에 에러가 발생했습니다. 에러 내용: " + error.text)
    },
    closeChangeAcodeModal: function() {
      this.hideModal('changeAcodeFloat')
    },
    changeAcode: function() {

      if(this.pageDevice.disabled) {
        this.makeToast("danger", "접속코드 변경 실패", "정지 중인 기기의 접속코드는 변경할 수 없습니다.")
        return false
      }
      if(this.changeAcodeConfirmSerial == "" || this.serial != this.changeAcodeConfirmSerial) {
        if(this.changeAcodeConfirmSerial == "") {
          this.makeToast("danger", "접속코드 변경 실패", "시리얼번호를 입력해주세요.")
        }
        else {
          this.makeToast("danger", "접속코드 변경 실패", "시리얼번호가 입력한 값과 다릅니다.")
        }
        window.document.getElementById("changeAcodeConfirmInput").focus()
        return false
      }
      else {
        this.changeAcodeDisabled = true
        this.showSpinner = true
        this.postJSONWithAuth(this.functionsServer + "/app/changeAcode", {
          acode: this.pageDevice.acode
        })
        .then(result=> {
          this.changeAcodeDisabled = false
          this.showSpinner = false
          if(result.status != 200) {
            this.makeToast("danger", "접속코드 변경 실패", "상태코드 " + result.status + ", 상태 메시지 " + result.statusText +"인 에러가 발생해서 접속코드를 변경하지 못했습니다.")
          }
          else {
            if(result.data.success) {

              this.$parent.$parent.makeToast("success", "접속코드 변경 성공", result.data.message)
              this.$parent.getAcode()
              this.changeAcodeConfirmAcode = ""
              this.closeChangeAcodeModal()

              if(this.pageDevice.config && typeof(this.pageDevice.config.ac) != "undefined") {
                let newVersion;
                if((this.pageDevice.config.ve*1)%2 == 0) {
                  newVersion = this.pageDevice.config.ve*1 + 2;
                }
                else {
                  newVersion = this.pageDevice.config.ve*1 + 1;
                }
                db.collection("devices").doc(this.pageDevice.id).update({
                  "cofig.ac": this.pageDevice.acode,
                  "config.ve": newVersion,
                })
              }
            }
            else {
              this.makeToast("danger", "접속코드 변경 실패", result.data.message)
            }
          }
        })
        .catch(error=> {
          this.changeAcodeDisabled = false
          this.showSpinner = false
          this.makeToast("danger", "기기 삭제 실패.", "서버로 요청을 보내지 못했습니다. 애러 내용:" + error)
        })
      }
    },
  },
}
</script>
<style scoped>
.stepTitle { border-style: solid; border-width: 0px 0px 1px 10px; border-color: gray;}
</style>
